"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var util_1 = require("./util");

var useWindowSize = function useWindowSize(initialWidth, initialHeight) {
  if (initialWidth === void 0) {
    initialWidth = Infinity;
  }

  if (initialHeight === void 0) {
    initialHeight = Infinity;
  }

  var _a = react_1.useState({
    width: util_1.isClient ? window.innerWidth : initialWidth,
    height: util_1.isClient ? window.innerHeight : initialHeight
  }),
      state = _a[0],
      setState = _a[1];

  react_1.useEffect(function () {
    if (util_1.isClient) {
      var handler_1 = function handler_1() {
        setState({
          width: window.innerWidth,
          height: window.innerHeight
        });
      };

      window.addEventListener('resize', handler_1);
      return function () {
        return window.removeEventListener('resize', handler_1);
      };
    } else {
      return undefined;
    }
  }, []);
  return state;
};

exports.default = useWindowSize;